export default __webpack_public_path__ + "static/media/Spinner-1s.eb8e9e48.svg";